import React, { useState } from 'react';
import { Container, Row, Col } from 'reactstrap';
import { PrimaryButton, SecondaryButton } from '../common/Buttons';
import './style.css';

const packagesData = [
  {
    emoji: "🚀",
    title: "STARTER",
    description: "Perfect to get your business online",
    withoutHostingPrice: 399.99,
    withHostingPrice: 599.99,
    features: [
      "Beautiful 5-page website",
      "Looks great on all devices",
      "Contact form for leads",
      "Google-friendly setup",
      "Social media links",
      "1 month of support"

    ],
    monthlyLink: 'https://payments.sjsocialmedia.com/b/28E28s5qRavKaz29ee2wU00',
    annualLink: 'https://payments.sjsocialmedia.com/b/28E7sM3iJ8nCgXqbmm2wU01',
    popular: false,
    bestFor: "Small businesses & freelancers"
  },
  {
    emoji: "⚙️",
    title: "PROFESSIONAL",
    description: "Everything you need to grow",
    withoutHostingPrice: 799.99,
    withHostingPrice: 999.99,
    features: [
      "Custom 10-page website",
      "Unique design just for you",
      "Advanced contact forms",
      "Google Analytics setup",
      "Blog to share your story",
      "Social media integration",
      "3 months of support"

    ],
    monthlyLink: 'https://payments.sjsocialmedia.com/b/28E28s5qRavKaz29ee2wU00',
    annualLink: 'https://payments.sjsocialmedia.com/b/28E7sM3iJ8nCgXqbmm2wU01',
    popular: true,
    bestFor: "Growing businesses"
  },
  {
    emoji: "🛒",
    title: "ONLINE STORE",
    withoutHostingPrice: 1599.99,
    withHostingPrice: 1999.99,
    description: "Start selling online today",
    features: [
      "Complete online store",
      "Accept credit card payments",
      "Showcase up to 50 products",
      "Shopping cart & checkout",
      "Track orders & inventory",
      "Customer accounts",
      "6 months of support"

    ],
    monthlyLink: 'https://payments.sjsocialmedia.com/b/28E28s5qRavKaz29ee2wU00',
    annualLink: 'https://payments.sjsocialmedia.com/b/28E7sM3iJ8nCgXqbmm2wU01',
    popular: false,
    bestFor: "Product-based businesses"
  },
  {
    emoji: "🧩",
    title: "CUSTOM",
    withoutHostingPrice: 0,
    withHostingPrice: 0,
    description: "Built exactly how you want it",
    price: "Let's Talk",
    features: [
      "Unlimited pages",
      "Any feature you can imagine",
      "Member login areas",
      "Multiple languages",
      "Custom integrations",
      "Dedicated project manager",
      "12 months of support"

    ],
    monthlyLink: 'https://payments.sjsocialmedia.com/b/28E28s5qRavKaz29ee2wU00',
    annualLink: 'https://payments.sjsocialmedia.com/b/28E7sM3iJ8nCgXqbmm2wU01',
    popular: false,
    bestFor: "Unique business needs"

  }
];

function PackagesSection({ id }) {
  const [isAnnual, setIsAnnual] = useState(false);

  const handleToggle = () => {
    setIsAnnual(prev => !prev);
  };

  return (
    <section className="packages-section py-5" id="packages">
      <Container>
        <Row className="justify-content-center text-center mb-5">
          <Col md="10" lg="8">
            <h2 className="h1 fw-bold mb-3">Choose What's Right for Your Business</h2>
            <p className="lead text-secondary mb-4">Professional websites • 30-day money-back guarantee</p>
            <div className="plans-toggle">
              <span className="plans-toggle-label">Without Hosting</span>
              <label className="switch">
                <input
                  type="checkbox"
                  checked={isAnnual}
                  onChange={handleToggle}
                />
                <span className="slider round"></span>
              </label>
              <span className="plans-toggle-label">With Hosting</span>
            </div>
          </Col>
        </Row>
        <Row>
          {packagesData.map((plan, index) => (
            <Col md="6" lg="3" className="mb-4" key={index}>
              <div
                className={
                  "plan-card" +
                  (plan.popular
                    ? isAnnual
                      ? " plan-card-popular-withoutHostingPrice"
                      : " plan-card-popular-withHostingPrice"
                    : "")
                }
                tabIndex={0}
                aria-label={plan.title + (plan.popular ? " (popular)" : "")}
              >
              {plan.popular && (
                <div className={`package-popular-badge ${isAnnual ? 'package-popular-badge--withoutHostingPrice' : 'package-popular-badge--withHostingPrice'}`}>★ Popular</div>
                )}
                <div>
                  <h6 className="plan-title">{plan.title}</h6>
                  <div className="plan-desc">{plan.description}</div>
                  <div className={`package-price ${isAnnual ? 'package-price--withoutHostingPrice' : 'package-price--withHostingPrice'}`}>
                    {plan.withoutHostingPrice === 0
                      ? 'Custom'
                      : `$${isAnnual ? plan.withHostingPrice.toFixed(2) : plan.withoutHostingPrice.toFixed(2)}`}
                  </div>
                  <ul className="plan-features">
                    {plan.features.map((f, i) => (
                      <li key={i}>{f}</li>
                    ))}
                  </ul>
                </div>
                <div className="plan-btn">
                  {isAnnual ? (
                    <PrimaryButton href={plan.annualLink}>
                      {plan.withoutHostingPrice === 0 ? 'Contact Sales' : 'Get Started'}
                    </PrimaryButton>
                  ) : (
                    <SecondaryButton href={plan.monthlyLink}>
                      {plan.withoutHostingPrice === 0 ? 'Contact Sales' : 'Get Started'}
                    </SecondaryButton>
                  )}
                </div>
              </div>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
}

export default PackagesSection;
